<template>
  <b-row :class="parentNodeClass">
    <b-col>
      <div class="d-flex">
        <div class="mr-auto">
          <slot name="left-content" class="header-title"></slot>
        </div>
        <div>
          <slot name="right-content"></slot>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    parentNodeClass: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.header-title {
  margin-bottom: 0;
  font-size: 1.5rem;
  font-weight: normal;
  line-height: 1.5;
}
</style>
